import React, { Component } from 'react';
import {
  Row,
  Col
} from 'react-bootstrap';
import { connect } from 'react-redux';
import NavigationBars from '../../components/HOC/withNavigationBars';
import { Button, Alert, Loader } from 'kangarootime-ui';
import DataTable from '../../components/DataTable';
import actions from './duck/actions';

class EditMenu extends Component {
  constructor (props) {
    super(props);

    this.state = {
      menu: props.menuToEdit,
      meals: props.menuMeals,
      showAlert: false,
      alertType: '',
      alertTitle: '',
      alertMessage: ''
    };
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.madeEditMenuRequest && !this.props.madeEditMenuRequest && this.props.editMenuSuccess) {
      this.showAlert('success', 'Success', 'Menu edited successfully!');
    }

    if (prevProps.madeEditMenuRequest && !this.props.madeEditMenuRequest && !this.props.editMenuSuccess && this.props.editMenuError !== '') {
      this.showAlert('danger', 'Error', this.props.editMenuError);
    }
  }

  showAlert = (type, title, message) => {
    this.setState({
      showAlert: true,
      alertType: type,
      alertTitle: title,
      alertMessage: message
    }, () => {
      setTimeout(() => {
        this.setState({
          showAlert: false,
          alertType: '',
          alertTitle: '',
          alertMessage: ''
        });
      }, 4500);
    });
  }

  // table editing functions
  onRowAdd = newData => (
    new Promise((resolve, reject) => {
      setTimeout(() => {
        {
          const { meals } = this.state;
          meals.push(newData);
          this.setState({ meals }, () => resolve());
        }
        resolve();
      }, 1000);
    })
  );

  onRowUpdate = (newData, oldData) => (
    new Promise((resolve, reject) => {
      setTimeout(() => {
        {
          const { meals } = this.state;
          const indexToUpdate = meals.indexOf(oldData);
          meals[indexToUpdate] = newData;
          this.setState({ meals }, () => resolve());
        }
        resolve();
      }, 1000);
    })
  );

  onRowDelete = oldData => (
    new Promise((resolve, reject) => {
      setTimeout(() => {
        {
          const { meals } = this.state;
          const indexToRemove = meals.indexOf(oldData);
          meals.splice(indexToRemove, 1);
          this.setState({ meals }, () => resolve());
        }
        resolve();
      }, 1000);
    })
  );

  submitMenuEdits = () => {
    const { menu, meals } = this.state;
    const editedMenu = {
      ...menu,
      originalMeals: menu.meals,
      updatedMeals: meals
    };

    this.props.editMenu(editedMenu);
  }

  cancelEdit = () => {
    this.props.resetMenu();
    this.props.history.goBack();
  }

  renderMealsTable = () => {
    const { meals, menu } = this.state;
    const { menuName, formattedDate } = menu;

    return (
      <DataTable
        title={`Edit ${menuName} for ${formattedDate}`}
        columns={[
          {
            title: 'Meal',
            field: 'mealtime',
            lookup: {
              'breakfast': 'Breakfast',
              'am_snack': 'AM Snack',
              'lunch': 'Lunch',
              'pm_snack': 'PM Snack'
            }
          },
          {
            title: 'Food',
            field: 'food'
          }
        ]}
        data={meals}
        editable={{
          onRowAdd: this.onRowAdd,
          onRowUpdate: this.onRowUpdate,
          onRowDelete: this.onRowDelete
        }}
        options={{
          search: false
        }}
      />
    );
  }

  render () {
    const { madeEditMenuRequest } = this.props;
    const { showAlert, alertType, alertTitle, alertMessage } = this.state;

    return (
      <NavigationBars>
        <Row>
          <Col md={12}>
            <div className='m-portlet' style={{ minHeight: '800px' }}>
              <Row style={{ justifyContent: 'center', marginBottom: 16 }}>
                <Loader loading={madeEditMenuRequest}>
                  { showAlert ? <Alert type={alertType} title={alertTitle}>{alertMessage}</Alert> : null }
                </Loader>
              </Row>
              <div style={{ margin: 16 }}>
                { this.renderMealsTable() }
                <div style={{ flexDirection: 'row', display: 'flex', marginTop: 16 }}>
                  <Button type='primary' onClick={this.submitMenuEdits} disabled={madeEditMenuRequest}>
                    Save Menu Changes
                  </Button>
                  <Button type='secondary' onClick={this.cancelEdit} disabled={madeEditMenuRequest}>
                    Cancel
                  </Button>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </NavigationBars>
    );
  }
}

function mapStateToProps (state) {
  return {
    menuToEdit: state.menus.edit.menuToEdit,
    menuMeals: state.menus.edit.menuToEdit.formattedMealsArray,
    madeEditMenuRequest: state.menus.edit.menuEditRequest,
    editMenuSuccess: state.menus.edit.menuEditSuccessful,
    editMenuError: state.menus.edit.menuEditError
  };
}

function mapDispatchToProps (dispatch) {
  return {
    resetMenu: () => dispatch(actions.resetMenuToEdit()),
    editMenu: (editedMenu) => dispatch(actions.editMenuRequest(editedMenu))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditMenu);
